import { UiOption } from '@/lib/helpers';
import { PublicServiceMeta } from './public-service.model';

export type PsSignal = {
  value: string | boolean;
  excerpts: string[];
  description: string;
};

export type PsSignalSet = {
  companyCountry: PsSignal;
  trainOnUserData: PsSignal;
  noModeration: PsSignal;
  confidence: number;
};

export type PsRisk = {
  base: {
    score: number;
    level: string;
  };
  weighted: {
    score: number;
    level: string;
  };
};

export const SignalOpts: UiOption[] = [
  { label: 'Trains on user data', value: 'trainOnUserData' },
  { label: 'Unmoderated use', value: 'noModeration' },
];

export type PsTag =
  | 'prompt-guard-output'
  | 'sensitive-data'
  | 'prompt-guard-input'
  | 'intent'
  | 'confidential-datasource'
  | 'confidential-data';

export type PsPolicySupport = 'content-controls' | 'sensitive-data' | 'intent';

export const PromptFeatureOpts: UiOption[] = [
  { label: 'PII Entities', value: 'pii-entities' },
  { label: 'Programming Language', value: 'programming-language' },
  { label: 'Regex Classifiers', value: 'regex-classifiers' },
  { label: 'Confidential Data', value: 'confidential-data' },
  { label: 'Prompt Injection', value: 'prompt-injection' },
  { label: 'Harmful Content', value: 'harmful-content' },
  { label: 'Intent Classifiers', value: 'intent' },
];

export const getListedNewServices = (
  publicServices: PublicServiceMeta[],
  newServiceIds: string[]
): PublicServiceMeta[] =>
  publicServices.filter(({ id, status }) => newServiceIds.includes(id) && status !== 'inactive');
